import { render, staticRenderFns } from "./categoryPicker.vue?vue&type=template&id=3df5e542&scoped=true"
import script from "./categoryPicker.vue?vue&type=script&lang=js"
export * from "./categoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5e542",
  null
  
)

export default component.exports